import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';

// Styles
import { useCreateRaindrop } from '@Modal/hooks/raindrop/useCreateRaindrop';
import { CreateRaindropForm } from './CreateRaindropForm';

export const CreateRaindropModalDialog = () => {
  const { showCreateRaindropForm, handleCreateCancel } = useCreateRaindrop();

  return (
    <>
      {showCreateRaindropForm && (
        <ClosableModal
          name="CreateRaindrop"
          title="Create a Raindrop Campaign"
          open={showCreateRaindropForm}
          onClose={handleCreateCancel}
          sx={{ overflowY: 'scroll', width: '80vw', height: '90vh' }}
        >
          <CreateRaindropForm />
        </ClosableModal>
      )}
    </>
  );
};
